import React from "react";
import styles from "./ErrorBoundary.module.scss";
import i18n from "@i18n/i18n";

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false, error: null });
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    if (this.props.fallback) return this.props.fallback;

    const { fullScreen } = this.props;

    return (
      <div className={fullScreen ? styles.fullScreen : styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>{i18n.t("errors.somethingWrong")}</h2>
          <p className={styles.description}>
            {i18n.t("errors.somethingWrong")}
          </p>
          <div className={styles.actions}>
            <button className={styles.button} onClick={this.handleReset}>
              {i18n.t("errors.tryAgain")}
            </button>
            <button
              className={`${styles.button} ${styles.buttonSecondary}`}
              onClick={() => (window.location.href = "/main")}
            >
              {i18n.t("errors.goHome")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
